import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { WoodTypeCrudService } from 'src/app/shared/services/wood-type-crud.service';
import { Type } from 'src/app/shared/interfaces/type';


@Component({
  selector: 'app-types',
  templateUrl: './types.component.html',
  styleUrls: ['./types.component.scss']
})
export class TypesComponent implements OnInit {

  types: Type[];
  type: Type;
  selectedTypes: Type[] = [];

  typeDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private typeService : WoodTypeCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Barrel Management'},
      {label: 'Types'}
    ];

    this.types = [];
    this.type = { } as Type ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.typeService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.types = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Type = jsonItem as Type;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.types.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
   //this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.typeService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.types);
            doc.save('types.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.types);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "types");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedTypes);
      // console.log('SAVEC CSV LOCATIONS ', this.types);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedTypes, 'types', exportCols);
   // this.exportService.exportToCsv(this.types, 'types', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.type = {} as Type;
    this.submitted = false;
    this.typeDialog = true;
  }

  deleteSelectedTypes() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected types?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.types = this.types.filter(val => !this.selectedTypes.includes(val));
            
            this.selectedTypes.forEach( type => this.typeService.delete(type.$key));
            this.selectedTypes = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Typess Deleted', life: 3000});
        }
    });
  }

  editType(type: Type) {
    this.type = {...type};
    this.typeDialog = true;
  }

  deleteType(type: Type) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + type.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.types = this.types.filter(val => val.$key !== type.$key);
            this.type = {} as Type;
            this.typeService.delete(type.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Type Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.typeDialog = false;
    this.submitted = false;
  }

  saveType() {
    this.submitted = true;

    if ( this.type.name.trim() ) {
      this.type.isEnabled = true;

      if (this.type.$key) {
          this.types[this.findIndexById(this.type.$key)] = this.type;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Type Updated', life: 3000});
          this.typeService.update(this.type);
        } else {
          this.type.position = this.types.length;
          this.typeService.add(this.type);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Type Created', life: 3000});
      this.types = [...this.types];
    }

    this.typeDialog = false;
    this.type = { } as Type;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.types.length; i++) {
        if (this.types[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeType(type : Type) {
    //console.log("SAVE", type);
    this.typeService.update(type);
  }

  completePosition(type : Type) {
   // console.log("SAVE", type);
  //  this.typeService.updateType(type);


    if ( this.newPosition > -1 ) {
        type.position = this.newPosition;
        type = this.checkPositionLimits(type);
        this.reorderElements(type);
        //this.updateDB(type);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.types);
    // const myClonedArray = [];
    // this.types.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.types.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.types.length - 1 - event.dropIndex;
    const typeToMove = this.types[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.types[index] = this.types[index+1];
        this.types[index].position = index;
        this.typeService.update(this.types[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.types[index] = this.types[index-1];
        this.types[index].position = index;
        this.typeService.update(this.types[index]);
      }
    } 
    this.types[endIndex] = typeToMove;
    this.types[endIndex].position = endIndex;
    this.typeService.update(this.types[endIndex]);
  }

  // onFieldEdit(type: Spray, fieldName: string): void {
  //   //console.log(this.types);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + type[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       type.position = this.newPosition;
  //       type = this.checkPositionLimits(type);
  //       this.reorderElements(type);
  //       //this.updateDB(type);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(type);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.types.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, type: Type) {
    // console.log("event" +event);
    if (type.position != null && type.position > -1) {
      this.previousPosition = type.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(type: Type) {
    console.log('check ',type.position + ' ' + this.types.length);
    if (!type.position) {
     // console.log('check 1');
      return this.type;
    }
    if (type.position < 0) {
      type.position = 0;
      // console.log('check 2');
      return type;
    }
    if (type.position > this.types.length) {
      type.position = this.types.length - 1;
    //  console.log('check 3', type.position);
      return type;
    }
   // console.log('check 4');
    return type;
  }

  async reorderElements(type: Type) {
    this.newPosition = this.newPosition  > this.types.length ? this.types.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === type.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const typeToMove = this.types[startIndex];
   // console.log('Item to move: ', this.types[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.types);
        console.log('Item to +1: ', this.types[index+1]);

        this.types[index] = this.types[index+1];
        this.types[index].position = index;
        // console.log('Move: ', this.types[index+1]);
        // console.log('Move pos: ', this.types[index].position);
        //await this.updateDB(this.types[index]);
        this.typeService.update(this.types[index]);
     //   console.log('Update DB: ', this.types[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.types[index] = this.types[index-1];
        this.types[index].position = index;
        this.typeService.update(this.types[index]);
      }
    } 
    this.types[endIndex] = typeToMove;
    this.types[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.typeService.update(this.types[endIndex]);
    
    // const myClonedArray = [];
    // this.types.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.types = myClonedArray;
   // this.getAllRecords();
  }
}


